import { memo, useCallback } from 'react';
import styled from '@emotion/styled';
import Tippy from '@tippyjs/react';

import { LOLLIPOP_ZINDEX } from '@hotjar/webapp/features/Playbacks/Timeline/Lollipops/Lollipop';

import type { Recording } from '../types';
import { useRealTimeStore } from '../store/realTimeStore';
import { RelevantActionNotificationContent } from './RelevantActionNotificationContent';

// The width is used in the by the Playbacks component to check if RelevantActionNotification collides with a Highlight.
// It has to be update if RelevantActionNotification's width increase or decrease its size.
export const RELEVANT_ACTION_NOTIFICATION_WIDTH_IN_PX = 58;

const StyledPopover = styled(Tippy)`
  &[data-animation='slide-up'][data-state='hidden'] {
    opacity: 0;

    transform: translateY(40px);
  }

  background-color: transparent;

  .tippy-content {
    padding: 0;
  }
`;

interface Props {
  onShare: (recording: Recording, startAt?: boolean, startAtTime?: number) => void;
  onCreate: () => void;
  recording: Recording;
  showStickerLabels: boolean;
}

const RelevantActionNotificationUnmemo = ({
  onShare,
  onCreate,
  recording,
  showStickerLabels,
}: Props): JSX.Element => {
  const xPositionInPercent = useRealTimeStore(
    useCallback((state) => (state.currentTimeWithLessPrecision / state.duration) * 100, []),
  );

  return (
    <div
      style={{
        width: `${RELEVANT_ACTION_NOTIFICATION_WIDTH_IN_PX}px`,
      }}
    >
      <StyledPopover
        offset={[0, 20]}
        zIndex={LOLLIPOP_ZINDEX}
        animation="slide-up"
        arrow={false}
        interactive
        placement="top"
        visible
        content={
          <RelevantActionNotificationContent
            onCreate={onCreate}
            onShare={() => onShare(recording, true)}
            showStickerLabels={showStickerLabels}
          />
        }
      >
        <div
          style={{
            position: 'absolute',
            left: `${xPositionInPercent}%`,
          }}
        />
      </StyledPopover>
    </div>
  );
};

export const RelevantActionNotification = memo(RelevantActionNotificationUnmemo);
